module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/be25fca420a7f95f05e8b87530324c9a.png";